import React from 'react';
import { UserHeader } from './UserHeader';
import { Sidebar } from './Sidebar';
import { useUser } from '../../contexts/UserContext';
import { Navigate } from 'react-router-dom';
interface UserLayoutProps {
  children: React.ReactNode;
  requiredUserType?: 'admin' | 'investor' | 'farmer';
}
export const UserLayout: React.FC<UserLayoutProps> = ({
  children,
  requiredUserType
}) => {
  const {
    isAuthenticated,
    userType
  } = useUser();
  // Redirect if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-439" />;
  }
  // Redirect if not the required user type (if specified)
  if (requiredUserType && userType !== requiredUserType) {
    return <Navigate to={`/${userType}/dashboard`} replace data-id="element-440" />;
  }
  return <div className="flex flex-col min-h-screen bg-wheat-gold/10" data-id="element-441">
      <UserHeader data-id="element-442" />
      <div className="flex flex-1" data-id="element-443">
        <Sidebar data-id="element-444" />
        <main className="flex-1 p-4 md:p-6 overflow-auto" data-id="element-445">{children}</main>
      </div>
    </div>;
};